export abstract class HideLabelsStrategyService {
    abstract isHideLabels(term?:string):boolean;

}
